import loadable from '@loadable/component';
import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useParams,
} from 'react-router-dom';
import { ConfirmPage } from '../pages/confirm/confirm';
import { LinearProgress } from '@mui/material';
import { UserContext } from './logged-in.router';

const LoadingIndicator = () => <LinearProgress />;

const LoggedInRouter = loadable(
  async () => {
    const { LoggedInRouter } = await import('./logged-in.router');
    return (props: RouterProps) => <LoggedInRouter {...props} />;
  },
  {
    fallback: <LoadingIndicator />,
  },
);

const LoggedOutRouter = loadable(async () => {
  const { LoggedOutRouter } = await import('./logged-out.router');
  return (props: RouterProps) => <LoggedOutRouter {...props} />;
});

const DarksitePublicRouter = loadable(async () => {
  const { DarksitePublicRouter } =
    await import('../pages/darksite/darksite.public.router');
  return () => <DarksitePublicRouter />;
});

const CrisisRoomVideoLazy = loadable(
  async () => {
    const { CrisisRoomVideo } =
      await import('../pages/crisis-room/edit/segments/video');
    return (props: { videoToken: string }) => <CrisisRoomVideo {...props} />;
  },
  {
    fallback: <LoadingIndicator />,
  },
);

export interface RouterProps {
  pathPrefix: string;
}

const CrisisRoomVideoWrapper: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  return id ? <CrisisRoomVideoLazy videoToken={id} /> : null;
};

export const AppRouter: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/video-call/:id" element={<CrisisRoomVideoWrapper />} />
        <Route path="/confirm/:id" element={<ConfirmPage />} />
        <Route path="/darksite/*" element={<DarksitePublicRouter />} />
        <Route
          path="/login/*"
          element={<LoggedOutRouter pathPrefix="/login" />}
        />
        <Route path="*" element={<LoggedInRouter pathPrefix="" />} />
      </Routes>
    </Router>
  );
};
